import i18n from '@app/plugins/i18n';
import { ContactService } from '@pbx/services/ContactService';
import { toUserDate } from '@shared/helpers/date_format';
import { getRecordFilePath } from '@shared/helpers/url';

export async function DetailedStatsFormatter(items) {
  const operators = await ContactService.getSelect();
  return items.map((item) => {
    item.music_file = GetStatsMusicFile(item);
    item.contact_name = GetOperatorsNameById(item.contact_id, operators);
    return item;
  });
}

export async function GeneralStatsFormatter(data, group_by) {
  if (group_by === 'date') {
    return data.map((item) => {
      return {
        ...item,
        group: toUserDate(item.group)
      };
    });
  }

  if (group_by === 'contact') {
    const operators = await ContactService.getSelect();
    return data.map((item) => {
      const name = GetOperatorsNameById(item.group, operators);
      return {
        ...item,
        group: name
      };
    });
  }

  if (group_by === 'sip_account') {
    return data.map((item) => {
      return {
        ...item,
        group: item.group
      };
    });
  }

  return data.map((stat) => {
    return {
      ...stat,
      group: i18n.t(`pbx.stat.common.field.${stat.group}`)
    };
  });
}

function GetOperatorsNameById(id, operators) {
  const find_operator = operators.find((f) => f.id === id);
  if (find_operator) {
    return `${find_operator.last_name} ${find_operator.first_name}`;
  }
  return i18n.t('pbx.stat.contact_not_fixed');
}

function GetStatsMusicFile(item) {
  if (item.recording && item.recording.state === 'finished') {
    const recording = item.recording;
    return {
      title: recording.file,
      src: getRecordFilePath(recording)
    };
  }
  return null;
}
